import InputTypesEnum from '../../../Enums/InputTypesEnum';
import PlanningAssignmentService from '../../../Services/PlanningAssignmentService';

class ServiceAccountManagerEditItem {
  constructor(serviceItem) {
    this.ServiceId = serviceItem.VPlanningServiceItemId;
    this.AccountManagerUserId = serviceItem.PlanningAccountManagerUserId;
    this.ApplyToAllCountries = true;
    this.CountryIds = [];
  }
}

export default class ServiceAccountManagerEditWindowDescription {
  static titleForCreate = 'Edit Account Manager';
  static titleForEdit = 'Edit Account Manager';
  static itemType = ServiceAccountManagerEditItem;
  static serviceFunction = async (item) =>
    PlanningAssignmentService.SetServiceAccountManager(
      item.ServiceId,
      item.AccountManagerUserId,
      item.ApplyToAllCountries,
      item.CountryIds
    );

  static pagesInGeneralEditWizzard = [
    {
      label: 'Account Manager',
      fields: [
        {
          fieldName: 'AccountManagerUserId',
          label: 'Account Manager',
          className: 'col-12',
          type: InputTypesEnum.UserSelect,
        },
        {
          fieldName: 'ApplyToAllCountries',
          label: 'Apply to all countries',
          className: 'col-12',
          type: InputTypesEnum.Bool,
        },
        {
          fieldName: 'CountryIds',
          label: 'Apply to countries',
          className: 'col-12',
          type: InputTypesEnum.ServiceCountryMultiSelect,
          idFilter: 'ServiceId',
          hide: (item) => item.ApplyToAllCountries === true || item.ApplyToAllCountries === 'true',
        },
      ],
    },
  ];
}
